import { FormFields } from './TrackSessionForm/validation';

import { CreateTrackedSession } from '../../types/api';

import * as api from '@cssat/acorn-service-delivery';

import { fetchServicePlan } from '../../lib/fakeServiceData';
import { TrainingUser } from '../../types/user';
import { adaptWithChangesForm } from './formApiAdapters/withChanges';
import { adaptAsPlannedForm } from './formApiAdapters/asPlanned';
import { adaptNotDeliveredForm } from './formApiAdapters/notDelivered';

export type CreateTrackedSessionAdapter = (
  values: FormFields
) => Promise<CreateTrackedSession>;

export const adaptCreateTrackedSession = (
  user: TrainingUser
): CreateTrackedSessionAdapter => {
  return async (values: FormFields): Promise<CreateTrackedSession> => {
    const service = await fetchServicePlan(values.service);
    switch (values.serviceStatus) {
      case api.Status.AsPlanned:
        return adaptAsPlannedForm(values, user, service);
      case api.Status.NotDelivered:
        return adaptNotDeliveredForm(values, user, service);
      case api.Status.WithChanges:
        return adaptWithChangesForm(values, user, service);
      default:
        throw new Error('Incompatible form values provided');
    }
  };
};
